import clsx from 'clsx';
import Button from 'components/form/Button';
import React, { ReactNode } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useSidebarStore from 'state/useSidebar';
import HeadBar from './HeadBar';
import useUserStore from 'state/userStore';

interface DashboardLayoutProps {
  children: ReactNode;
}

const NavItems = [
  {
    title: 'Dashboard',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6"
      >
        <path
          fillRule="evenodd"
          d="M3 6a3 3 0 013-3h2.25a3 3 0 013 3v2.25a3 3 0 01-3 3H6a3 3 0 01-3-3V6zm9.75 0a3 3 0 013-3H18a3 3 0 013 3v2.25a3 3 0 01-3 3h-2.25a3 3 0 01-3-3V6zM3 15.75a3 3 0 013-3h2.25a3 3 0 013 3V18a3 3 0 01-3 3H6a3 3 0 01-3-3v-2.25zm9.75 0a3 3 0 013-3H18a3 3 0 013 3V18a3 3 0 01-3 3h-2.25a3 3 0 01-3-3v-2.25z"
          clipRule="evenodd"
        />
      </svg>
    ),
    link: '/dashboard',
  },
  {
    title: 'Invest',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="h-6 w-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
        />
      </svg>
    ),
    link: '/dashboard/invest',
  },
  {
    title: 'Wallet',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6"
      >
        <path d="M2.273 5.625A4.483 4.483 0 015.25 4.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0018.75 3H5.25a3 3 0 00-2.977 2.625zM2.273 8.625A4.483 4.483 0 015.25 7.5h13.5c1.141 0 2.183.425 2.977 1.125A3 3 0 0018.75 6H5.25a3 3 0 00-2.977 2.625zM5.25 9a3 3 0 00-3 3v6a3 3 0 003 3h13.5a3 3 0 003-3v-6a3 3 0 00-3-3H15a.75.75 0 00-.75.75 2.25 2.25 0 01-4.5 0A.75.75 0 009 9H5.25z" />
      </svg>
    ),
    link: '/dashboard/wallet',
  },
  {
    title: 'Transactions',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6"
      >
        <path d="M12 7.5a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" />
        <path
          fillRule="evenodd"
          d="M1.5 4.875C1.5 3.839 2.34 3 3.375 3h17.25c1.035 0 1.875.84 1.875 1.875v9.75c0 1.036-.84 1.875-1.875 1.875H3.375A1.875 1.875 0 011.5 14.625v-9.75zM8.25 9.75a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0zM18.75 9a.75.75 0 00-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 00.75-.75V9.75a.75.75 0 00-.75-.75h-.008zM4.5 9.75A.75.75 0 015.25 9h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75H5.25a.75.75 0 01-.75-.75V9.75z"
          clipRule="evenodd"
        />
        <path d="M2.25 18a.75.75 0 000 1.5c5.4 0 10.63.722 15.6 2.075 1.19.324 2.4-.558 2.4-1.82V18.75a.75.75 0 00-.75-.75H2.25z" />
      </svg>
    ),
    link: '/dashboard/transactions',
  },
  {
    title: 'Withdraw',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6"
      >
        <path d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 01-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004zM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 01-.921.42z" />
        <path
          fillRule="evenodd"
          d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 6a.75.75 0 00-1.5 0v.816a3.836 3.836 0 00-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 01-.921-.421l-.879-.66a.75.75 0 00-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 001.5 0v-.81a4.124 4.124 0 001.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 00-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 00.933-1.175l-.415-.33a3.836 3.836 0 00-1.719-.755V6z"
          clipRule="evenodd"
        />
      </svg>
    ),
    link: '/dashboard/withdraw',
  },
];

const AccountNavItems = [
  // {
  //   title: 'Rates',
  //   icon: (
  //     <svg
  //       xmlns="http://www.w3.org/2000/svg"
  //       viewBox="0 0 24 24"
  //       fill="currentColor"
  //       className="h-6 w-6"
  //     >
  //       <path
  //         fillRule="evenodd"
  //         d="M1.5 7.125c0-1.036.84-1.875 1.875-1.875h6c1.036 0 1.875.84 1.875 1.875v3.75c0 1.036-.84 1.875-1.875 1.875h-6A1.875 1.875 0 011.5 10.875v-3.75zm12 1.5c0-1.036.84-1.875 1.875-1.875h5.25c1.035 0 1.875.84 1.875 1.875v8.25c0 1.035-.84 1.875-1.875 1.875h-5.25a1.875 1.875 0 01-1.875-1.875v-8.25zM3 16.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875v2.25c0 1.035-.84 1.875-1.875 1.875h-5.25A1.875 1.875 0 013 18.375v-2.25z"
  //         clipRule="evenodd"
  //       />
  //     </svg>
  //   ),
  //   link: '/dashboard/rates',
  // },
  {
    title: 'Stocks',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="h-6 w-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.25 21v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21m0 0h4.5V3.545M12.75 21h7.5V10.75M2.25 21h1.5m18 0h-18M2.25 9l4.5-1.636M18.75 3l-1.5.545m0 6.205l3 1m1.5.5l-1.5-.5M6.75 7.364V3h-3v18m3-13.636l10.5-3.819"
        />
      </svg>
    ),
    link: '/dashboard/stocks',
  },
  {
    title: 'Settings',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6"
      >
        <path
          fillRule="evenodd"
          d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 00-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 00-2.282.819l-.922 1.597a1.875 1.875 0 00.432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 000 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 00-.432 2.385l.922 1.597a1.875 1.875 0 002.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 002.28-.819l.923-1.597a1.875 1.875 0 00-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 000-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 00-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 00-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 00-1.85-1.567h-1.843zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
          clipRule="evenodd"
        />
      </svg>
    ),
    link: '/dashboard/settings',
  },
];

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const { isOpen, setIsOpen } = useSidebarStore();
  const { clearUser } = useUserStore();
  const { pathname } = useLocation();

  const handleClose = (e: any) => {
    e.stopPropagation();
    setIsOpen(false);
  };

  const navigate = useNavigate();

  const handleLogout = () => {
    clearUser();
    window.localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <div className="flex overflow-hidden bg-white md:h-screen">
      <div
        className={clsx(
          'overflow-x-hidden bg-[#5f5f5f1a] transition-all lg:w-72 lg:overflow-x-visible',
          isOpen
            ? 'fixed inset-y-0 z-40 w-full lg:static'
            : 'hidden w-0 lg:block'
        )}
      >
        <div
          className="brand-border scrollbar relative flex h-full w-3/4 flex-none flex-col overflow-y-auto border-r bg-white md:w-72"
          onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
        >
          <div className="sticky inset-x-0 top-0 mb-2 space-y-5 bg-white px-3 pb-3 pt-5">
            <div className="flex items-center justify-between">
              <div className="flex items-end gap-x-1">
                <div className="h-[50px] w-[50px]">
                  <img
                    src="/assets/logo.png"
                    alt="app-logo"
                    className="h-full w-full object-cover"
                  />
                </div>

                <p className="mb-1 font-mono text-xl font-bold">Blockchain</p>
              </div>{' '}
              <Button onClick={() => setIsOpen(false)} className="lg:hidden">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="h-6 w-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </span>
              </Button>
            </div>
          </div>
          <div className="my-10 flex flex-col justify-center gap-y-4 px-3">
            {NavItems.map((item, index) => (
              <Button key={index} className="w-full" onClick={handleClose}>
                <Link to={`${item.link}` || '/'}>
                  <div
                    className={clsx(
                      item.link === pathname
                        ? 'border-black bg-black text-white'
                        : 'hover:bg-stone-300',
                      'flex w-full cursor-pointer items-center space-x-5 rounded-md py-3 pl-10'
                    )}
                  >
                    <span
                      className={clsx(
                        item.link === pathname
                          ? 'fill-white'
                          : 'text-brand-blue'
                      )}
                    >
                      {item.icon}
                    </span>
                    <p>{item.title}</p>
                  </div>
                </Link>
              </Button>
            ))}
          </div>
          <br />
          <div className="my-14 flex flex-col justify-center gap-y-4 px-3">
            {AccountNavItems.map((item, index) => (
              <Button key={index} className="w-full" onClick={handleClose}>
                <Link to={`${item.link}` || '/'}>
                  <div
                    className={clsx(
                      item.link === pathname
                        ? 'border-black bg-black text-white'
                        : 'hover:bg-stone-300',
                      'flex w-full cursor-pointer items-center space-x-5 rounded-md py-3 pl-10'
                    )}
                  >
                    <span
                      className={clsx(
                        item.link === pathname
                          ? 'fill-white'
                          : 'text-brand-blue'
                      )}
                    >
                      {item.icon}
                    </span>
                    <p>{item.title}</p>
                  </div>
                </Link>
              </Button>
            ))}
          </div>

          <div className="flex flex-col justify-center gap-y-4 px-6">
            <div className="w-full">
              <Button
                className="h-full w-full !px-0 text-red-500 hover:!brightness-100"
                onClick={handleLogout}
              >
                <div className="flex w-full cursor-pointer items-center space-x-5 rounded-md py-3 pl-10 hover:bg-zinc-100">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="h-6 w-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
                      />
                    </svg>
                  </span>
                  <span>Logout</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-1 flex-col">
        <HeadBar />
        <div className="scrollbar mt-[70px] overflow-y-auto bg-white lg:mt-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
